import { COLORS, DSBottomSheet } from '@repo/design-system/index'
import { QIcon_menu_button_hamburger } from '@repo/icons/index'
import classNames from 'classnames'
import { useEffect, useState } from 'react'
import { useMaterials } from '../../../../modules/apis/student/material/queries'
import { APP_SCREEN_NAME, STACK_ACTIVITY_NAME } from '../../../../modules/hooks/common/appRouterVars'
import useAppRouter from '../../../../modules/hooks/common/useAppRouter'
import useIsWebview from '../../../../modules/hooks/common/useIsWebview'
import useReturnFullUrl from '../../../../modules/hooks/webview/common/useReturnFullUrl'
import { n_common, s_my_original } from '../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../modules/i18n/useTranslation'
import urls from '../../../../modules/urls'
import { useAITutorStack } from '../../../../pages/[lang]/webview/ai-tutor'
import { useLessonsStack } from '../../../../pages/[lang]/webview/lessons'
import { useMaterialsStack } from '../../../../pages/[lang]/webview/materials'
import { BOOKMARKED_MATERIALS } from './SelectMaterialBody'

interface ICategorySection {
  categoryId: number
  setCategoryId: (categoryId: number) => void
  setSelectedHashId: (hashId: string) => void
  isList?: boolean
  isConversation?: boolean | { [x: string]: boolean }
  isAITutor?: boolean | { [x: string]: boolean }
}

const CategorySection = ({
  categoryId,
  setCategoryId,
  setSelectedHashId,
  isList = false,
  isConversation = false,
  isAITutor = false,
}: ICategorySection) => {
  const { t, isLocaleKO } = useTranslation()
  const { useMaterialsFlow } = useMaterialsStack()
  const { push } = useMaterialsFlow()
  const router = useAppRouter({ stackPush: push })

  const isLessonActivity = router.asPath.includes('/webview/lessons')
  console.log(isLessonActivity, 'isLessonActivity')
  const { useLessonsFlow } = useLessonsStack()
  const { push: lessonPush } = useLessonsFlow()
  const lessonRouter = useAppRouter({ stackPush: lessonPush })

  const { useAITutorFlow } = useAITutorStack()
  const { push: useAITutorPush } = useAITutorFlow()
  const aiTutorRouter = useAppRouter({ stackPush: useAITutorPush })
  const getFullUrl = useReturnFullUrl()

  const isWebview = useIsWebview()
  const [hashTags, setHashTags] = useState([])
  const [showBottomSheet, setShowBottomSheet] = useState(false)
  const { data: materialsData, isFetching: materialsIsFetching } = useMaterials()

  const onClickHashTag = (hashTag) => {
    if (isAITutor) {
      aiTutorRouter.push(urls.webview.aiTutor.discussion.materialCategory(hashTag.id), {
        appScreenName: APP_SCREEN_NAME.STACK_SCREEN,
        appSendData: {
          url: getFullUrl(urls.webview.aiTutor.discussion.materialCategory(hashTag.id)),
        },
      })
      return
    }

    isLessonActivity
      ? lessonRouter.push(urls.student.newPortal.materials.category(hashTag.id), {
          stackActivity: STACK_ACTIVITY_NAME.LESSON_MATERIAL_CATEGORY_ACTIVITY,
          stackSendData: { categoryId: hashTag.id },
        })
      : router.push(urls.student.newPortal.materials.category(hashTag.id), {
          stackActivity: STACK_ACTIVITY_NAME.MATERIAL_CATEGORY_ACTIVITY,
          stackSendData: { categoryId: hashTag.id },
        })
  }

  useEffect(() => {
    if (materialsData && !materialsIsFetching) {
      if (isList) {
        setHashTags([...materialsData.upper_hashtags])
      } else if (isConversation || isAITutor) {
        const conversationCategories = materialsData.upper_hashtags.filter((item) => item.id !== 19) // 내가 만드는 수업
        setHashTags([RECOMMENED_CATEGORY, ...conversationCategories])
      } else {
        setHashTags([RECOMMENED_CATEGORY, ...materialsData.upper_hashtags])
      }
    }
  }, [materialsData, materialsIsFetching])

  const RECOMMENED_CATEGORY = {
    id: 0,
    title_kr: t(n_common.btn_recommend),
    title_en: t(n_common.btn_recommend),
    title_zh_chs: t(n_common.btn_recommend),
    title_zh_cht: t(n_common.btn_recommend),
    title_ja: t(n_common.btn_recommend),
    title_vi: t(n_common.btn_recommend),
  }

  const handleHashButton = (id) => {
    setCategoryId(id)
    const newUrl = new URL(window.location.href)
    newUrl.searchParams.set('category', id)
    window.history.pushState({}, '', newUrl)
    setSelectedHashId('All')
  }

  const SkeletonArrayList = new Array(11).fill('')

  if (isList) {
    return (
      <div className="no-scrollbar flex w-full flex-nowrap gap-x-[8px] gap-y-[8px] overflow-hidden overflow-x-scroll sm:flex-wrap sm:gap-x-[16px] sm:grid sm:grid-cols-6">
        <button
          className={classNames(
            'Body1-16Md border-1 flex max-w-[90px] min-h-[42px]  justify-center whitespace-nowrap rounded-[8px] px-[16px] items-center sm:hidden'
          )}
          onClick={() => setShowBottomSheet((prev) => !prev)}
        >
          <QIcon_menu_button_hamburger width={20} height={20} color={COLORS.GRAY500} />
        </button>
        {hashTags.map((hashTag) => {
          return (
            <button
              className={classNames(
                hashTag.id === Number(categoryId ? categoryId : 0) && '',
                'Body1-16Md border-1 flex w-[160px] sm:w-auto justify-center whitespace-nowrap rounded-[8px] px-[16px] pb-[6px] pt-[8px]'
              )}
              key={hashTag.id}
              onClick={() => onClickHashTag(hashTag)}
            >
              {t([
                hashTag.title_kr,
                hashTag.title_en,
                '',
                hashTag.title_zh_chs,
                hashTag.title_zh_cht,
                hashTag.title_ja,
                hashTag.title_vi,
              ])}
            </button>
          )
        })}
        {showBottomSheet && (
          <DSBottomSheet
            id="categoryBottomSheet"
            isOpen={showBottomSheet}
            setIsOpen={setShowBottomSheet}
            closeOnDim={true}
            closeOnDrag={true}
          >
            <div className="">
              {hashTags.map((hashTag) => {
                return (
                  <button
                    className={classNames(
                      hashTag.id === Number(categoryId ? categoryId : 0) && '',
                      'Body2-14Md flex w-[160px] justify-start whitespace-nowrap px-[20px] py-[16px]'
                    )}
                    key={hashTag.id}
                    onClick={() => {
                      setShowBottomSheet(false)
                      onClickHashTag(hashTag)
                    }}
                  >
                    {t([
                      hashTag.title_kr,
                      hashTag.title_en,
                      '',
                      hashTag.title_zh_chs,
                      hashTag.title_zh_cht,
                      hashTag.title_ja,
                      hashTag.title_vi,
                    ])}
                  </button>
                )
              })}
            </div>
          </DSBottomSheet>
        )}
      </div>
    )
  } else {
    return (
      <div
        className={classNames(
          !isWebview && 'lg:mt-[40px]',
          'border-b-1 no-scrollbar sticky top-[0px] z-20 mb-[24px] flex h-[60px] w-full flex-row overflow-x-scroll bg-white text-gray-500 sm:fixed sm:top-[150px] sm:mt-[40px] lg:mb-[0px] lg:h-auto lg:max-w-[180px] lg:border-0 lg:border-gray-100'
        )}
      >
        <div className="no-scrollbar flex w-full flex-row gap-[4px] overflow-hidden overflow-x-scroll pr-[32px] lg:flex-col">
          {materialsIsFetching && !materialsData ? (
            SkeletonArrayList.map((_, i) => {
              return (
                <div
                  key={i}
                  className="Body1-16Bd lg:Body2-14Bd hidden h-[38px] w-full animate-pulse justify-start whitespace-nowrap bg-gray-200 py-[8px] px-[12px] sm:flex lg:rounded-[70px]"
                ></div>
              )
            })
          ) : (
            <>
              {hashTags.slice(0, 1).map((hashTag) => {
                return (
                  <button
                    className={classNames(
                      hashTag.id === Number(categoryId ? categoryId : 0) &&
                        'border-b-[2px] border-black text-black lg:border-b-0 lg:bg-purple-50 lg:text-purple-500',
                      'Body1-16Bd lg:Body2-14Bd flex w-full items-center justify-start whitespace-nowrap py-[8px] px-[12px] lg:rounded-[70px]'
                    )}
                    key={hashTag.id}
                    onClick={() => handleHashButton(hashTag.id)}
                  >
                    {t([
                      hashTag.title_kr,
                      hashTag.title_en,
                      '',
                      hashTag.title_zh_chs,
                      hashTag.title_zh_cht,
                      hashTag.title_ja,
                      hashTag.title_vi,
                    ])}
                  </button>
                )
              })}
              {hashTags.length > 0 && (
                <button
                  className={classNames(
                    BOOKMARKED_MATERIALS === categoryId &&
                      'border-b-[2px] border-black text-black lg:border-b-0 lg:bg-purple-50  lg:text-purple-500',
                    'Body1-16Bd lg:Body2-14Bd flex h-full w-full items-center justify-start self-center whitespace-nowrap py-[8px] px-[12px] lg:rounded-[70px]'
                  )}
                  onClick={() => handleHashButton(BOOKMARKED_MATERIALS)}
                >
                  {t(s_my_original.saved_packets)}
                </button>
              )}
              {hashTags.slice(1).map((hashTag) => {
                return (
                  <button
                    className={classNames(
                      hashTag.id === Number(categoryId ? categoryId : 0) &&
                        'border-b-[2px] border-black text-black lg:border-b-0 lg:bg-purple-50 lg:text-purple-500',
                      'Body1-16Bd lg:Body2-14Bd flex w-full items-center justify-start whitespace-nowrap py-[8px] px-[12px] lg:rounded-[70px]'
                    )}
                    key={hashTag.id}
                    onClick={() => handleHashButton(hashTag.id)}
                  >
                    {t([
                      hashTag.title_kr,
                      hashTag.title_en,
                      '',
                      hashTag.title_zh_chs,
                      hashTag.title_zh_cht,
                      hashTag.title_ja,
                      hashTag.title_vi,
                    ])}
                  </button>
                )
              })}
            </>
          )}
        </div>
      </div>
    )
  }
}

export default CategorySection
